import { SaveDialogContent, SaveButton } from "@/components/SaveForm";
import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Skeleton } from "@/components/ui/skeleton";
import { Dialog, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Truck, Plus, Globe, Trash2 } from "lucide-react";

const inp = "bg-slate-950 border-slate-700 text-slate-100 mt-1";

export default function Suppliers() {
  const { can } = useAuth();
  const [list, setList] = useState(null);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({});

  const load = () => api.get("/suppliers").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.nome) { toast.error("Nome é obrigatório."); return; }
    try { await api.post("/suppliers", { ...form, lead_time_padrao: Number(form.lead_time_padrao) || 0 }); toast.success("Fornecedor cadastrado."); setOpen(false); setForm({}); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };

  const handleDelete = async (s) => {
    if (!window.confirm(`Excluir definitivamente este fornecedor?\n\nDurante esta fase de implantação, os vínculos de demonstração relacionados poderão ser removidos.\nEsta ação não poderá ser desfeita.`)) return;
    try { await api.delete(`/suppliers/${s.id}/permanent`, { params: { force: true } }); toast.success("Fornecedor excluído definitivamente."); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };

  if (list === null) return <Skeleton className="h-96 bg-slate-800" />;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between gap-3">
        <div><h1 className="font-display text-3xl font-bold text-slate-50">Fornecedores</h1><p className="text-slate-400 text-sm">Nacionais e importados (China).</p></div>
        {can("COMPRAS") && <Button data-testid="btn-new-supplier" onClick={() => setOpen(true)} className="bg-sky-700 hover:bg-sky-600"><Plus className="h-4 w-4 mr-1" /> Novo fornecedor</Button>}
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {list.map((s) => (
          <Card key={s.id} className="card-metal p-5 relative group">
            {can() && (
              <button data-testid={`btn-delete-supplier-${s.id}`} onClick={() => handleDelete(s)} title="Excluir definitivamente"
                className="absolute top-3 right-3 z-10 rounded-md bg-slate-950/70 p-1.5 text-rose-400 hover:text-rose-300 hover:bg-rose-950/60 opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity">
                <Trash2 className="h-4 w-4" />
              </button>
            )}
            <div className="flex items-center gap-2"><Truck className="h-5 w-5 text-sky-400" /><h3 className="font-semibold text-slate-100">{s.nome}</h3></div>
            <div className="mt-2 text-sm text-slate-400 space-y-1">
              <div className="flex items-center gap-1"><Globe className="h-3.5 w-3.5" /> {s.pais || "—"} {s.pais === "China" && <span className="text-rose-400 text-xs">(importado)</span>}</div>
              <div>Contato: {s.contato || "—"}</div>
              <div>{s.email || "—"} · {s.telefone || "—"}</div>
              <div className="font-mono text-xs">Lead time padrão: {s.lead_time_padrao || 0} dias</div>
            </div>
          </Card>
        ))}
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <SaveDialogContent className="bg-slate-900 border-slate-700 text-slate-100">
          <DialogHeader><DialogTitle className="font-display text-2xl">Novo fornecedor</DialogTitle></DialogHeader>
          <div className="grid sm:grid-cols-2 gap-3">
            <div><Label>Nome *</Label><Input className={inp} onChange={(e) => setForm({ ...form, nome: e.target.value })} /></div>
            <div><Label>País</Label><Input className={inp} onChange={(e) => setForm({ ...form, pais: e.target.value })} /></div>
            <div><Label>Contato</Label><Input className={inp} onChange={(e) => setForm({ ...form, contato: e.target.value })} /></div>
            <div><Label>E-mail</Label><Input className={inp} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
            <div><Label>Telefone</Label><Input className={inp} onChange={(e) => setForm({ ...form, telefone: e.target.value })} /></div>
            <div><Label>Lead time (dias)</Label><Input type="number" className={inp} onChange={(e) => setForm({ ...form, lead_time_padrao: e.target.value })} /></div>
          </div>
          <DialogFooter><Button variant="ghost" onClick={() => setOpen(false)}>Cancelar</Button><SaveButton onClick={save} className="bg-sky-700 hover:bg-sky-600">Salvar</SaveButton></DialogFooter>
        </SaveDialogContent>
      </Dialog>
    </div>
  );
}
